// extracted by mini-css-extract-plugin
export default {"service-card":"ServiceCard_service-card__9dXu1"};